var map = {
	"./grid-kendo-ca.json": "f2dc",
	"./grid-kendo-de.json": "9b9d",
	"./grid-kendo-en.json": "b1f2",
	"./grid-kendo-es.json": "c335",
	"./grid-kendo-eu.json": "b600",
	"./grid-kendo-fr.json": "dc6f",
	"./grid-kendo-gl.json": "4c4c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fd7d";